// Path: ./src/hooks/useRoles.ts
import { useState, useEffect, useCallback } from "react";
import { adminApiService } from "../utils/api";
import { GfRole } from "@swagger/typescript-fetch-goflyer";

export const useRoles = () => {
  const [rolesList, setRolesList] = useState<GfRole[]>(); //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) maybe we should do the mapping here to create label

  const fetchRoles = useCallback(async () => {
    try {
      const roles =
        await adminApiService.getManyBaseGfRoleAdminControllerGfRole();

      setRolesList(roles.data);
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  }, []);

  useEffect(() => {
    fetchRoles();
  }, []);

  return { rolesList, fetchRoles };
};
